export default "__VITE_ASSET__BxDtIHug__"